import { apiFetch } from "../../lib/api";

export type CheckInOut = {
  id: string;
  station_id: string;
  duration_minutes: number;
  expires_at: string;
  checked_out_at: string | null;
  checked_in_at: string;
};

export type CheckInSummary = {
  active_count: number;
  next_leaving_at: string | null;
};

export async function createCheckIn(payload: {
  station_id: string;
  lat: number;
  lng: number;
  duration_minutes?: number;
}): Promise<CheckInOut> {
  return apiFetch<CheckInOut>("/check-ins", { method: "POST", body: payload });
}

export async function checkOut(): Promise<void> {
  return apiFetch<void>("/check-ins", { method: "DELETE" });
}

export async function getMyCheckIn(): Promise<CheckInOut | null> {
  return apiFetch<CheckInOut | null>("/check-ins/me");
}

export async function getCheckInSummary(stationId: string): Promise<CheckInSummary> {
  return apiFetch<CheckInSummary>(`/check-ins/stations/${stationId}/summary`);
}
